import getFeatures from "./getFeatures";

const getExperimentEligibility = state =>
  getFeatures(state).experimentEligibility;

export default getExperimentEligibility;
